import Logo from "./Logo";
import Menu from "./Menu";
import SubMenu from "./SubMenu";

const LateralPanel = ({ handleButtonClick, address } ) => {
    return (
        <div className="w-1/4 flex flex-col h-screen bg-neutral-950 min-w-[350px]">
            <div className="flex-shrink-0">
                <Logo />
            </div>
            <div className="flex-grow flex flex-col">
                <div>
                    <Menu handleButtonClick={handleButtonClick} />
                </div>
                <div className="flex-grow"></div>
                <div>
                    <SubMenu handleButtonClick={handleButtonClick} address={address} />
                </div>
            </div>
        </div>
    );
};

export default LateralPanel;